import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FreqConversionUtil } from 'src/app/models/FreqConversionUtil';
import { NavaidModel } from 'src/app/models/navaid';
import { PointsService } from 'src/app/services/points.service';
import { ChannelFreqObject } from 'src/app/models/ChannelFreqObject';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { HttpClient } from '@angular/common/http';
import * as fileSaver from 'file-saver';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { ErrorModel } from 'src/app/models/error';
import { NavaidsService } from 'src/app/services/navaids.service';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-duplicate-navaids',
  templateUrl: './duplicate-navaids.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class DuplicateNavaidsComponent implements OnInit {

  @Input()
  duplicates:NavaidModel[];

  @Input()
  navaids:NavaidModel[];

  @Input()
  selected: boolean[];

  @Input()
  formatfile: string;

  constructor(public bsModalRef: BsModalService,
  public pointsService: PointsService,
  private endpointService: EndpointsService,
  private http: HttpClient,
  private modalControlService: ModalControlService
  ) {
   }

  ngOnInit(): void {
  }
  cancel():void{
    this.bsModalRef.hide();
  }

  selectAll() : void {
    this.selected.fill(true);
  }

  deselectAll() : void {
    this.selected.fill(false);
  }

 static setToArray(set:Set<NavaidModel>){
    let duplicates: NavaidModel[] = []
    set.forEach(
      navaid => {
            let freq : ChannelFreqObject = FreqConversionUtil.findByChannel(navaid.channel);
            navaid.vhfTunFreqInput = freq != null &&  freq.vorFreq != null ? freq.vorFreq.toString() : null;
            duplicates.push(navaid);
          });
    return duplicates;
}
static removeDuplicatesFromNavaids(duplicates: Set<NavaidModel> , navaids:NavaidModel[]){
  for(let duplicate of duplicates){
    navaids = navaids.filter((navaid)=> !NavaidModel.navaidsAreDuplicates(navaid,duplicate))
  }
  return navaids;
}
//  static  getMapOfDuplicatesWithinFile(navaids: NavaidModel[]):  Map<string, NavaidModel[]> {
//     let map: Map<string, NavaidModel[]> = new Map();
//     for(let navaid of navaids){
//       let key = navaid.navaidid+navaid.icaocc ;
//       if(!map.has(key)){
//         map.set(key,[navaid]);
//         continue;
//       }
//       let duplicates = map.get(key);
//       for(let duplicateNavaid of duplicates){
//         if(NavaidModel.navaidsAreDuplicates(duplicateNavaid,navaid)){
//           duplicates.push(navaid);
//           map.set(key,duplicates);
//           break;
//         }
//       }
//     }

//     return map;
//   }
  static  getMapOfDuplicatesWithinFile(navaids: NavaidModel[]):  Set<NavaidModel> {
    let duplicates: Set<NavaidModel>  = new Set<NavaidModel>();
    for(let i = 0; i < navaids.length-1; i++){
      for(let j = i + 1; j < navaids.length;j++){
        if(NavaidModel.navaidsAreDuplicates(navaids[i],navaids[j])){
          duplicates.add(navaids[i]);
          duplicates.add(navaids[j]);
        }
      }
    }
    return duplicates;

  }


  static addDuplicatesBetweenFileAndLayers(navaidsInFile:NavaidModel[],duplicates:Set<NavaidModel>,pointsController:PointsService, navaidController : NavaidsService):  Set<NavaidModel> {
    let layersNavaids:NavaidModel[] = pointsController.getAllNavaidsFromLayers();


    for(let navaid of layersNavaids){
      let navaidPayload = navaidController.getNavaidPayload(navaid);
      for(let navaidInFile of navaidsInFile){
        if(NavaidModel.navaidsAreDuplicates(navaidInFile,navaidPayload,true)){
          duplicates.add(navaidInFile);
          duplicates.add(navaidPayload);
        }
      }
    }
    return duplicates;
  }
  public static importCheckForDuplicates(navaids:NavaidModel[],modalService:BsModalService,pointsController:PointsService, navaidsController : NavaidsService,formatFile:string){
    let duplicates:Set<NavaidModel> = DuplicateNavaidsComponent.getMapOfDuplicatesWithinFile(navaids);
    duplicates =  DuplicateNavaidsComponent.addDuplicatesBetweenFileAndLayers(navaids,duplicates,pointsController, navaidsController);
    if(duplicates.size>0){ //duplicates exist
      const bsRef:BsModalRef = modalService.show(DuplicateNavaidsComponent);
      bsRef.content.duplicates = DuplicateNavaidsComponent.setToArray(duplicates);
      bsRef.content.navaids = DuplicateNavaidsComponent.removeDuplicatesFromNavaids(duplicates,navaids);
      bsRef. content.selected = Array(bsRef.content.duplicates.length).fill(false);
      bsRef.content.formatfile = formatFile;
    }
    else{
      pointsController.importNavAids(navaids,formatFile);
    }
  }
  proceedWithImport(){
    this.bsModalRef.hide();
    for(let i = 0; i < this.duplicates.length; i++){
      if(this.selected[i])
        this.navaids.push(this.duplicates[i])
    }
    this.pointsService.importNavAids(this.navaids,this.formatfile)
  }

  changeSelected(i){
   this.selected[i] = !this.selected[i];
  }

  exportNavaidsToCsv(){
    this.http.post(this.endpointService.duplicatedNavaidsCSVUrl,
      JSON.stringify(this.duplicates),
      this.endpointService.fileHttpOptions
      ).subscribe(
        (blob:Blob) => {
          fileSaver.saveAs(blob, "navaidFile.csv");
        },
        (error) => {
          this.modalControlService.showMesssageModal("error","Error generating csv file");
        }
      )
  }

}
